import { gql, useQuery } from '@apollo/client';

export const GET_JOB_BY_ID = gql`
  query getJobById($jobId: ObjectId!) {
    getJobById(jobId: $jobId) {
      _id
      title
      activityKey
      description
      workingHours
      salaryType
      vacation
      appraisalReview
      advertisementDescription
      questionnaireSettingsIds
      neededSkills
      companyId
      createdBy
      company {
        name
      }
      documents {
        _id
        documentLabelId
        documentLabel {
          _id
          name
        }
        documentTemplatesIds
        documentTemplates {
          _id
          title
        }
      }
      jobLocations {
        _id
        companyLocationId
        companyLocation {
          name
        }
        companyBusinessAddressId
        companyBusinessAddress {
          zipCode
          city
          street
          country
        }
        companyDepartmentId
        companyDepartment {
          name
        }
        jobSupervisors {
          _id
          jobPlacesCount
          supervisorJobTitle
          supervisorMemberId
          supervisorMember {
            profile {
              displayName
            }
          }
          assignedMembers {
            _id
            createdBy
            profile {
              displayName
              avatarUrl
            }
          }
        }
      }
    }
  }
`;

export const useGetJobById = (jobId?: string) => {
  const { data, loading } = useQuery(GET_JOB_BY_ID, {
    variables: { jobId },
    fetchPolicy: 'network-only',
    skip: !jobId
  });

  return {
    job: data?.getJobById || {},
    loading,
  };
};
